import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';

export function credentialsInterceptor(skipUrls?: string[]): HttpInterceptorFn {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    if (shouldSkipUrl(req.url, skipUrls)) {
      return next(req);
    }
    const updatedReq = addCredentials(req);
    return next(updatedReq);
  };
}

function shouldSkipUrl(url: string, skipUrls?: string[]): boolean {
  if (!skipUrls || skipUrls.length === 0) {
    return false;
  }

  return skipUrls.some((skipUrl) => url.includes(skipUrl));
}

function addCredentials(req: HttpRequest<unknown>): HttpRequest<unknown> {
  return req.clone({
    withCredentials: true,
  });
}
